import React from "react";

export default function FormField({ label, name, value, onChange, type = "text", rows, required }) {
  const commonClass =
    "mt-2 w-full bg-transparent border-b border-neutral-700 py-2 focus:outline-none focus:border-[#fbf3e4] transition-colors";
  return (
    <div>
      <label className="text-xs tracking-[0.3em] text-neutral-400">
        {label} {required && "*"}
      </label>
      {rows ? (
        <textarea
          rows={rows}
          value={value}
          onChange={onChange}
          className={`${commonClass} resize-none`}
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={onChange}
          className={commonClass}
        />
      )}
    </div>
  );
}
